var map = {
	"./Icons/Belt/belt-1.png": "9c77",
	"./Icons/Belt/belt-2.png": "5dd2",
	"./Icons/Belt/belt-3.png": "8be5",
	"./Icons/ItemRecipe/X-ray.png": "0e80",
	"./Icons/ItemRecipe/accelerator-1.png": "2a10",
	"./Icons/ItemRecipe/accelerator-2.png": "14c4",
	"./Icons/ItemRecipe/accelerator-3.png": "50f6",
	"./Icons/ItemRecipe/accumulator-full.png": "1817",
	"./Icons/ItemRecipe/accumulator.png": "c38d",
	"./Icons/ItemRecipe/anti-matter.png": "3e36",
	"./Icons/ItemRecipe/antimatter-energy-fuel.png": "59ce",
	"./Icons/ItemRecipe/assembler-1.png": "7152",
	"./Icons/ItemRecipe/assembler-2.png": "d3b6",
	"./Icons/ItemRecipe/assembler-3.png": "184b",
	"./Icons/ItemRecipe/bamboo-crystal.png": "2553",
	"./Icons/ItemRecipe/belt-1.png": "b523",
	"./Icons/ItemRecipe/belt-2.png": "e43d",
	"./Icons/ItemRecipe/belt-3.png": "7867",
	"./Icons/ItemRecipe/c-matrix.png": "40a6",
	"./Icons/ItemRecipe/casimir-crystal-lv2.png": "5280",
	"./Icons/ItemRecipe/casimir-crystal.png": "750c",
	"./Icons/ItemRecipe/charging-pole.png": "7014",
	"./Icons/ItemRecipe/chemical-plant.png": "1582",
	"./Icons/ItemRecipe/circuit-board.png": "4440",
	"./Icons/ItemRecipe/coal-ore.png": "1b83",
	"./Icons/ItemRecipe/copper-ore.png": "8210",
	"./Icons/ItemRecipe/copper-plate.png": "0f43",
	"./Icons/ItemRecipe/crystal-rubber-lv0.png": "4a96",
	"./Icons/ItemRecipe/crystal-rubber.png": "4c29",
	"./Icons/ItemRecipe/deuterium-energy-fuel.png": "e7ec",
	"./Icons/ItemRecipe/deuterium-formula.png": "c46e",
	"./Icons/ItemRecipe/deuterium.png": "7a3d",
	"./Icons/ItemRecipe/diamond-lv2.png": "a346",
	"./Icons/ItemRecipe/diamond-ore.png": "de24",
	"./Icons/ItemRecipe/diamond.png": "4129",
	"./Icons/ItemRecipe/dyson-sphere-component.png": "891c",
	"./Icons/ItemRecipe/e-matrix.png": "b272",
	"./Icons/ItemRecipe/electric-motor.png": "d5a5",
	"./Icons/ItemRecipe/em-rail-ejector.png": "4e02",
	"./Icons/ItemRecipe/energy-exchanger.png": "6f89",
	"./Icons/ItemRecipe/fractal-silica.png": "7ad5",
	"./Icons/ItemRecipe/fractionator.png": "bf8b",
	"./Icons/ItemRecipe/frame-material.png": "4b04",
	"./Icons/ItemRecipe/fuel-plant.png": "df5d",
	"./Icons/ItemRecipe/fuel-thruster.png": "b0ce",
	"./Icons/ItemRecipe/fusion-capacitor.png": "27cf",
	"./Icons/ItemRecipe/fusion-power-station.png": "737b",
	"./Icons/ItemRecipe/fusion-reactor.png": "9a16",
	"./Icons/ItemRecipe/g-matrix.png": "6d31",
	"./Icons/ItemRecipe/gas-hydrate.png": "eb00",
	"./Icons/ItemRecipe/gear-wheel.png": "114c",
	"./Icons/ItemRecipe/glass.png": "28ce",
	"./Icons/ItemRecipe/graphene-lv2.png": "13ad",
	"./Icons/ItemRecipe/graphene.png": "3112",
	"./Icons/ItemRecipe/graphite.png": "3c64",
	"./Icons/ItemRecipe/grating-ore.png": "494f",
	"./Icons/ItemRecipe/gravity-lens.png": "a758",
	"./Icons/ItemRecipe/hadron-collider.png": "b6b1",
	"./Icons/ItemRecipe/hydrogen-energy-fuel.png": "e328",
	"./Icons/ItemRecipe/hydrogen.png": "d723",
	"./Icons/ItemRecipe/hyper-magnetism-ring.png": "f84a",
	"./Icons/ItemRecipe/i-matrix.png": "e7ac",
	"./Icons/ItemRecipe/inserter-1.png": "b202",
	"./Icons/ItemRecipe/inserter-2.png": "fea4",
	"./Icons/ItemRecipe/inserter-3.png": "d054",
	"./Icons/ItemRecipe/interstellar-logistic-station.png": "a6ea",
	"./Icons/ItemRecipe/ion-thruster.png": "843b",
	"./Icons/ItemRecipe/iron-ore.png": "f1ed",
	"./Icons/ItemRecipe/iron-plate.png": "26d1",
	"./Icons/ItemRecipe/lab.png": "cd53",
	"./Icons/ItemRecipe/logistic-drone.png": "ec97",
	"./Icons/ItemRecipe/logistic-station.png": "8ac8",
	"./Icons/ItemRecipe/logistic-vessel.png": "452e",
	"./Icons/ItemRecipe/mag-turbine.png": "80eb",
	"./Icons/ItemRecipe/magnet.png": "a372",
	"./Icons/ItemRecipe/magnetism-wire.png": "18c2",
	"./Icons/ItemRecipe/micro-component.png": "cd75",
	"./Icons/ItemRecipe/mining-drill.png": "4fc0",
	"./Icons/ItemRecipe/mono-mag-ore.png": "40fb",
	"./Icons/ItemRecipe/nanotube-lv2.png": "9b88",
	"./Icons/ItemRecipe/nanotube.png": "f147",
	"./Icons/ItemRecipe/oil-extractor.png": "74e6",
	"./Icons/ItemRecipe/oil-refinery.png": "0f62",
	"./Icons/ItemRecipe/oil.png": "4a6c",
	"./Icons/ItemRecipe/orbital-collector.png": "b18e",
	"./Icons/ItemRecipe/orbital-substation.png": "286c",
	"./Icons/ItemRecipe/partical-capacitor-lv2.png": "5550",
	"./Icons/ItemRecipe/partical-capacitor.png": "2b30",
	"./Icons/ItemRecipe/particle-wide-band.png": "e019",
	"./Icons/ItemRecipe/photo-shifter-lv2.png": "aa2a",
	"./Icons/ItemRecipe/photo-shifter.png": "4e50",
	"./Icons/ItemRecipe/photon-capacitor-full.png": "eb7c",
	"./Icons/ItemRecipe/photon-formula.png": "ea8b",
	"./Icons/ItemRecipe/plane-filter.png": "7057",
	"./Icons/ItemRecipe/plant-fuel.png": "21c0",
	"./Icons/ItemRecipe/plasma-generator.png": "2947",
	"./Icons/ItemRecipe/plasma-refining.png": "0959",
	"./Icons/ItemRecipe/plastic.png": "4a57",
	"./Icons/ItemRecipe/prism.png": "5a2a",
	"./Icons/ItemRecipe/processor.png": "d639",
	"./Icons/ItemRecipe/quantum-processor.png": "bdaf",
	"./Icons/ItemRecipe/ray-receiver.png": "5716",
	"./Icons/ItemRecipe/refined-oil.png": "5f99",
	"./Icons/ItemRecipe/rocket.png": "233b",
	"./Icons/ItemRecipe/silicium-high-purity-lv2.png": "d99f",
	"./Icons/ItemRecipe/silicium-high-purity.png": "ac0e",
	"./Icons/ItemRecipe/silicium-ore.png": "8caf",
	"./Icons/ItemRecipe/silicium-single-crystal.png": "6fe8",
	"./Icons/ItemRecipe/smelter.png": "f431",
	"./Icons/ItemRecipe/solar-collector.png": "b332",
	"./Icons/ItemRecipe/solar-panel.png": "b3ef",
	"./Icons/ItemRecipe/space-warper-lv2.png": "e7bf",
	"./Icons/ItemRecipe/space-warper.png": "5147",
	"./Icons/ItemRecipe/splitter-4dir.png": "9252",
	"./Icons/ItemRecipe/spray-coater.png": "5322",
	"./Icons/ItemRecipe/steel-plate.png": "b1bd",
	"./Icons/ItemRecipe/stone-brick.png": "43c5",
	"./Icons/ItemRecipe/stone-ore.png": "7997",
	"./Icons/ItemRecipe/storage-1.png": "af22",
	"./Icons/ItemRecipe/storage-2.png": "415d",
	"./Icons/ItemRecipe/storage-tank.png": "5daf",
	"./Icons/ItemRecipe/strange-matter-generator.png": "3ed1",
	"./Icons/ItemRecipe/sulphuric-acid.png": "dacd",
	"./Icons/ItemRecipe/t-matrix.png": "8bad",
	"./Icons/ItemRecipe/terrain-tool.png": "cea3",
	"./Icons/ItemRecipe/tesla-coil.png": "2eee",
	"./Icons/ItemRecipe/titan-crystal.png": "b47b",
	"./Icons/ItemRecipe/titan-glass.png": "f2e4",
	"./Icons/ItemRecipe/titanium-alloy.png": "79b0",
	"./Icons/ItemRecipe/titanium-ore.png": "2a35",
	"./Icons/ItemRecipe/titanium-plate.png": "bb1e",
	"./Icons/ItemRecipe/u-matrix.png": "a946",
	"./Icons/ItemRecipe/vertical-launching-silo.png": "508c",
	"./Icons/ItemRecipe/water-pump.png": "9640",
	"./Icons/ItemRecipe/water.png": "56b5",
	"./Icons/ItemRecipe/wind-turbine.png": "0cec",
	"./Icons/ItemRecipe/wood.png": "84d0",
	"./Icons/Tech/0.png": "4250",
	"./Icons/Tech/1.png": "66e7",
	"./Icons/Tech/1001.png": "7909",
	"./Icons/Tech/1002.png": "aed0",
	"./Icons/Tech/1101.png": "dc04",
	"./Icons/Tech/1102.png": "2a7c",
	"./Icons/Tech/1103.png": "58fa",
	"./Icons/Tech/1111.png": "0ad1",
	"./Icons/Tech/1112.png": "503d",
	"./Icons/Tech/1113.png": "1bb4",
	"./Icons/Tech/1114.png": "001e",
	"./Icons/Tech/1120.png": "62ae",
	"./Icons/Tech/1121.png": "1026",
	"./Icons/Tech/1122.png": "5a92",
	"./Icons/Tech/1123.png": "9865",
	"./Icons/Tech/1124.png": "7823",
	"./Icons/Tech/1125.png": "d6b4",
	"./Icons/Tech/1126.png": "a8aa",
	"./Icons/Tech/1131.png": "a875",
	"./Icons/Tech/1132.png": "ae7c",
	"./Icons/Tech/1133.png": "0fbc",
	"./Icons/Tech/1134.png": "29a9",
	"./Icons/Tech/1141.png": "b043",
	"./Icons/Tech/1142.png": "975a",
	"./Icons/Tech/1143.png": "5011",
	"./Icons/Tech/1144.png": "3e8f",
	"./Icons/Tech/1145.png": "22ab",
	"./Icons/Tech/1151.png": "1a65",
	"./Icons/Tech/1152.png": "6d92",
	"./Icons/Tech/1153.png": "dc83",
	"./Icons/Tech/1201.png": "7682",
	"./Icons/Tech/1202.png": "3e47",
	"./Icons/Tech/1203.png": "2c2f",
	"./Icons/Tech/1301.png": "33c9",
	"./Icons/Tech/1302.png": "709f",
	"./Icons/Tech/1303.png": "0647",
	"./Icons/Tech/1311.png": "b014",
	"./Icons/Tech/1312.png": "0efb",
	"./Icons/Tech/1401.png": "a274",
	"./Icons/Tech/1402.png": "ada3",
	"./Icons/Tech/1403.png": "1279",
	"./Icons/Tech/1411.png": "9dc4",
	"./Icons/Tech/1412.png": "45cc",
	"./Icons/Tech/1413.png": "ed14",
	"./Icons/Tech/1414.png": "0962",
	"./Icons/Tech/1415.png": "c673",
	"./Icons/Tech/1416.png": "5ddb",
	"./Icons/Tech/1501.png": "6f40",
	"./Icons/Tech/1502.png": "e282",
	"./Icons/Tech/1503.png": "c29e",
	"./Icons/Tech/1504.png": "228e0",
	"./Icons/Tech/1505.png": "56ab",
	"./Icons/Tech/1506.png": "fd5f",
	"./Icons/Tech/1507.png": "b751",
	"./Icons/Tech/1508.png": "8efd",
	"./Icons/Tech/1511.png": "1323",
	"./Icons/Tech/1512.png": "b88f",
	"./Icons/Tech/1521.png": "1335",
	"./Icons/Tech/1522.png": "8019",
	"./Icons/Tech/1523.png": "c567",
	"./Icons/Tech/1601.png": "8161",
	"./Icons/Tech/1602.png": "11be",
	"./Icons/Tech/1603.png": "b94c",
	"./Icons/Tech/1604.png": "59dc",
	"./Icons/Tech/1605.png": "c8ac",
	"./Icons/Tech/1606.png": "cfbf",
	"./Icons/Tech/1701.png": "322c",
	"./Icons/Tech/1702.png": "bbb0",
	"./Icons/Tech/1703.png": "e1c9",
	"./Icons/Tech/1704.png": "6a1e",
	"./Icons/Tech/1705.png": "5201",
	"./Icons/Tech/1711.png": "e559",
	"./Icons/Tech/1712.png": "b476",
	"./Icons/Tech/2101.png": "143c",
	"./Icons/Tech/2102.png": "2592",
	"./Icons/Tech/2103.png": "e340",
	"./Icons/Tech/2104.png": "afe0",
	"./Icons/Tech/2105.png": "0001",
	"./Icons/Tech/2106.png": "1ffd",
	"./Icons/Tech/2201.png": "c638",
	"./Icons/Tech/2202.png": "f7bf",
	"./Icons/Tech/2203.png": "f24e",
	"./Icons/Tech/2204.png": "10e0",
	"./Icons/Tech/2205.png": "a980",
	"./Icons/Tech/2206.png": "d0a9",
	"./Icons/Tech/2207.png": "5e79",
	"./Icons/Tech/2208.png": "45d4",
	"./Icons/Tech/2301.png": "5340",
	"./Icons/Tech/2302.png": "bf7c",
	"./Icons/Tech/2303.png": "f68a",
	"./Icons/Tech/2304.png": "f251",
	"./Icons/Tech/2305.png": "c61d",
	"./Icons/Tech/2306.png": "ca9f",
	"./Icons/Tech/2401.png": "f9b1",
	"./Icons/Tech/2402.png": "4797",
	"./Icons/Tech/2403.png": "3eb8",
	"./Icons/Tech/2404.png": "dc11",
	"./Icons/Tech/2405.png": "4c96",
	"./Icons/Tech/2406.png": "b655",
	"./Icons/Tech/2407.png": "398b",
	"./Icons/Tech/2501.png": "6a09",
	"./Icons/Tech/2502.png": "63d8",
	"./Icons/Tech/2503.png": "1f8f",
	"./Icons/Tech/2504.png": "07b4",
	"./Icons/Tech/2505.png": "e874",
	"./Icons/Tech/2506.png": "1758",
	"./Icons/Tech/2601.png": "aca4",
	"./Icons/Tech/2602.png": "1b51",
	"./Icons/Tech/2603.png": "cf5e",
	"./Icons/Tech/2604.png": "1e80",
	"./Icons/Tech/2605.png": "a30e",
	"./Icons/Tech/2606.png": "3b8e",
	"./Icons/Tech/2901.png": "ccfe",
	"./Icons/Tech/2902.png": "afff",
	"./Icons/Tech/2903.png": "266f",
	"./Icons/Tech/2904.png": "4ae0",
	"./Icons/Tech/3101.png": "3c0f",
	"./Icons/Tech/3102.png": "bd8f",
	"./Icons/Tech/3103.png": "27d5",
	"./Icons/Tech/3104.png": "7e8c",
	"./Icons/Tech/3105.png": "faae",
	"./Icons/Tech/3106.png": "e9c0",
	"./Icons/Tech/3201.png": "dd20",
	"./Icons/Tech/3202.png": "d2fc",
	"./Icons/Tech/3203.png": "faa6",
	"./Icons/Tech/3204.png": "e2af",
	"./Icons/Tech/3205.png": "28bc",
	"./Icons/Tech/3206.png": "261b",
	"./Icons/Tech/3207.png": "4897",
	"./Icons/Tech/3208.png": "a48e",
	"./Icons/Tech/3301.png": "4f49",
	"./Icons/Tech/3302.png": "a8ac",
	"./Icons/Tech/3303.png": "072c",
	"./Icons/Tech/3304.png": "097f",
	"./Icons/Tech/3305.png": "b53a",
	"./Icons/Tech/3401.png": "536e",
	"./Icons/Tech/3402.png": "700d",
	"./Icons/Tech/3403.png": "761f",
	"./Icons/Tech/3404.png": "1375",
	"./Icons/Tech/3405.png": "79fc",
	"./Icons/Tech/3406.png": "0ffc",
	"./Icons/Tech/3407.png": "9a90",
	"./Icons/Tech/3501.png": "7e95",
	"./Icons/Tech/3502.png": "7aaf",
	"./Icons/Tech/3503.png": "3ca8",
	"./Icons/Tech/3504.png": "9ffd",
	"./Icons/Tech/3505.png": "080f",
	"./Icons/Tech/3506.png": "9e48",
	"./Icons/Tech/3507.png": "b791",
	"./Icons/Tech/3508.png": "f1f3",
	"./Icons/Tech/3601.png": "917d",
	"./Icons/Tech/3602.png": "769d",
	"./Icons/Tech/3603.png": "cf4c",
	"./Icons/Tech/3604.png": "9e7b",
	"./Icons/Tech/3605.png": "f54b",
	"./Icons/Tech/3606.png": "4a93",
	"./Icons/Tech/3701.png": "9c64",
	"./Icons/Tech/3702.png": "9444",
	"./Icons/Tech/3703.png": "6d6a",
	"./Icons/Tech/3704.png": "3dd6",
	"./Icons/Tech/3705.png": "8ce9",
	"./Icons/Tech/3706.png": "1c2e",
	"./Icons/Tech/3901.png": "377b",
	"./Icons/Tech/3902.png": "ab0b",
	"./Icons/Tech/3903.png": "382b",
	"./Icons/Tech/3904.png": "b74c",
	"./Icons/Tech/4101.png": "5751",
	"./Icons/Tech/4102.png": "4ec6",
	"./Icons/Tech/4103.png": "b913",
	"./Icons/Tech/4104.png": "fe80",
	"./Icons/Vein/bamboo-vein.png": "eefd",
	"./Icons/Vein/coal-vein.png": "0f52",
	"./Icons/Vein/copper-vein.png": "b22d",
	"./Icons/Vein/crysrub-vein.png": "ffbb",
	"./Icons/Vein/diamond-vein.png": "6256",
	"./Icons/Vein/fireice-vein.png": "50d0",
	"./Icons/Vein/fractal-vein.png": "72a0",
	"./Icons/Vein/grat-vein.png": "948f",
	"./Icons/Vein/iron-vein.png": "dceb",
	"./Icons/Vein/mag-vein.png": "4098",
	"./Icons/Vein/oil-vein.png": "40ab",
	"./Icons/Vein/silicium-vein.png": "03c5",
	"./Icons/Vein/stone-vein.png": "e69f",
	"./Icons/Vein/titanium-vein.png": "9d3b",
	"./Icons/Vein/unknown-vein.png": "9972",
	"./Icons/placeholder.png": "6af7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";